export enum ValidationRegex {
    EMAIL = "^([0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\\w]*[0-9a-zA-Z]\\.)+[a-zA-Z]{2,9})$",
    PHONENO = "[0-9]{10}",
    TEXT_ONLY = "^[a-zA-Z].*[\s\.]*$"

}